import { render, staticRenderFns } from "./busWitnessList.vue?vue&type=template&id=6f23608d&scoped=true"
import script from "./busWitnessList.vue?vue&type=script&lang=js"
export * from "./busWitnessList.vue?vue&type=script&lang=js"
import style0 from "./busWitnessList.vue?vue&type=style&index=0&id=6f23608d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f23608d",
  null
  
)

export default component.exports